import * as types from "./actionTypes";

const initialState = {
  data: [],
  limit: 12,
  total: 0,
  offset: 1,
  config: { name: "", key: "" },
  isPagesLoaded: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.CONTAINER_FETCH:
      return {
        ...state,
        config: action.config,
      };

    case types.CONTAINER_FETCH_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total,
        isPagesLoaded: true,
      };

    case types.CONTAINER_FETCH_NEXT_SUCCESS:
      return {
        ...state,
        data: [...state.data, ...action.payload.data],
        offset: state.offset + 1,
      };

    case types.CONTAINER_RESET:
      return initialState;

    default:
      return state;
  }
};
